export default "__VITE_ASSET__a97b88ee__"